export default __webpack_public_path__ + "static/media/NPL.3e7779b1.svg";